export enum DetailPageActionTypes {
  STORE_MERGE = '@@dp/STORE_MERGE',
  WatchlistToggle = '@@dp/WatchlistToggle',
  WatchlistToggleFailed = '@@dp/WatchlistToggleFailed',
  ClearWatchlistToggleFailure = '@@dp/ClearWatchlistToggleFailure',
  GetDevices = '@@dp/GetDevices',
  GetDevicesFailed = '@@dp/GetDevicesFailed',
  RefreshEpisode = '@@dp/ActionBox/RefreshEpisode',
  RefreshAtfActionBox = '@@dp/ActionBox/RefreshAtfActionBox',
  RefreshBtfActionBoxes = '@@dp/ActionBox/RefreshBtfActionBoxes',
  ResetPurchasingTransition = '@@dp/ActionBox/ResetPurchasingTransition',
  FailedPurchasingDueToClientDependency = '@@dp/ActionBox/FailedPurchasingDueToClientDependency',
  TriggerPurchasingTransition = '@@dp/ActionBox/TriggerPurchasingTransition', //Legacy Purchase
  TriggerPurchase = '@@dp/ActionBox/TriggerPurchase',
  PurchaseCancelled = '@@dp/ActionBox/PurchaseCancelled',
  PurchaseFailed = '@@dp/ActionBox/PurchaseFailed',
  TriggerRefund = '@@dp/ActionBox/TriggerRefund',
  RefundFailed = '@@dp/ActionBox/RefundFailed',
  RefundCancelled = '@@dp/ActionBox/RefundCancelled',
  CreateBanner = '@@dp/CreateBanner',
  ClearBanner = '@@dp/ClearBanner',
  SetPlayerCapabilities = '@@dp/player/SetPlayerCapabilities',
  PlaybackStart = '@@dp/player/PlaybackStart',
  PlaybackFailed = '@@dp/player/PlaybackFailed',
  PlaybackClosed = '@@dp/player/PlaybackClosed',
  DeeplinkingReady = '@@dp/DeeplinkingReady',
}
